import { render, staticRenderFns } from "./SurveyAssignmentDetail.vue?vue&type=template&id=6ac99a16&"
import script from "./SurveyAssignmentDetail.vue?vue&type=script&lang=ts&"
export * from "./SurveyAssignmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyAssignmentDetail.vue?vue&type=style&index=0&id=6ac99a16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports